import "./userupdate.css";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import useFetch from "../../hooks/useFetch";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userInputs } from "../../formSource";

// Modern SVG Icons
const Icons = {
  Location: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Phone: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z" />
    </svg>
  ),
  Calendar: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  User: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Mail: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    </svg>
  ),
  Save: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Reset: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 1 0 9-9m0 0v6m0-6h-6" />
    </svg>
  ),
};

const Single = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { data, loading } = useFetch(`https://api.moroccool.com/api/users/${id}`);

  const [info, setInfo] = useState({});

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setInfo({
        username: data.username || '',
        email: data.email || '',
        phone: data.phone || '',
        city: data.city || '',
        role: data.isAdmin ? 'admin' : 'user',
        img: data.img || ''
      });
    }
  }, [data]);

  const handleChange = e => {
    setInfo(prev => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleReset = () => {
    setInfo({
      username: data?.username || '',
      email: data?.email || '',
      phone: data?.phone || '',
      city: data?.city || '',
      role: data?.isAdmin ? 'admin' : 'user',
      img: data?.img || ''
    });
  };

  const navigate = useNavigate();

  const handleClick = async e => {
    e.preventDefault();
    try {
      const updatedUser = {
        ...info,
        isAdmin: info.role === 'admin'
      };
      await axios.put(`https://api.moroccool.com/api/users/${id}`, updatedUser);
      navigate("/users");
    } catch (err) {
      console.log(err);
    }
  };

  const getProviderLabel = (provider) => {
    if (provider === 'google.com') return { label: 'Google', className: 'google' };
    if (provider === 'facebook.com') return { label: 'Facebook', className: 'facebook' };
    if (provider === 'email') return { label: 'Email', className: 'email' };
    return { label: 'Unknown', className: 'email' };
  };

  const providerInfo = getProviderLabel(data?.oauthProvider);
  const avatarUrl = data?.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif";

  return (
    <div className="user-management-layout">
      <Sidebar />
      <div className="main-content-area">
        <Navbar />
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <span>Loading user data...</span>
          </div>
        ) : (
          <div className="dashboard-container">
            {/* Profile Hero Section */}
            <div className="profile-hero">
              <div className="profile-hero-content">
                <div className="profile-avatar-wrapper">
                  <img
                    src={avatarUrl}
                    alt={data?.username || "User"}
                    className="profile-avatar-hero"
                    onError={(e) => {
                      e.target.src = "https://i.ibb.co/MBtjqXQ/no-avatar.gif";
                    }}
                  />
                  <div className="profile-status">
                    <span className={`status-dot ${data?.isAdmin ? 'admin' : 'user'}`} />
                  </div>
                </div>
                <div className="profile-info-hero">
                  <h1>{data?.username || '—'}</h1>
                  <p>{data?.email || '—'}</p>
                  <div className="profile-tags-hero">
                    <span className={`tag-provider ${providerInfo.className}`}>
                      {providerInfo.label}
                    </span>
                    <span className={`tag-role ${data?.isAdmin ? 'admin' : 'user'}`}>
                      {data?.isAdmin ? 'Administrator' : 'Standard User'}
                    </span>
                  </div>
                </div>
                <div className="profile-actions-hero">
                  <button className="btn-secondary" onClick={handleReset}>
                    <Icons.Reset />
                    Reset
                  </button>
                  <button className="btn-primary" onClick={handleClick}>
                    <Icons.Save />
                    Save Changes
                  </button>
                </div>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="stats-grid-modern">
              <div className="stat-card-modern">
                <div className="stat-icon-modern">
                  <Icons.Location />
                </div>
                <div className="stat-content-modern">
                  <span className="stat-label-modern">Location</span>
                  <span className="stat-value-modern">{data?.city || 'Not specified'}</span>
                </div>
              </div>
              <div className="stat-card-modern">
                <div className="stat-icon-modern">
                  <Icons.Phone />
                </div>
                <div className="stat-content-modern">
                  <span className="stat-label-modern">Phone</span>
                  <span className="stat-value-modern">{data?.phone || 'Not specified'}</span>
                </div>
              </div>
              <div className="stat-card-modern">
                <div className="stat-icon-modern">
                  <Icons.Calendar />
                </div>
                <div className="stat-content-modern">
                  <span className="stat-label-modern">Joined</span>
                  <span className="stat-value-modern">
                    {data?.createdAt ? new Date(data.createdAt).toLocaleDateString('fr-FR', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric'
                    }) : '—'}
                  </span>
                </div>
              </div>
              <div className="stat-card-modern">
                <div className="stat-icon-modern">
                  <Icons.User />
                </div>
                <div className="stat-content-modern">
                  <span className="stat-label-modern">User ID</span>
                  <span className="stat-value-modern id">{data?._id?.slice(-8) || '—'}</span>
                </div>
              </div>
            </div>

            {/* Edit Form */}
            <div className="edit-card-modern">
              <div className="edit-header-modern">
                <div className="edit-header-left">
                  <Icons.Edit />
                  <h2>Edit User Information</h2>
                </div>
              </div>
              <form>
                <div className="form-grid-modern">
                  {userInputs.map((input) => (
                    <div className="form-group-modern" key={input.id}>
                      <label>{input.label}</label>
                      <div className="input-field-modern">
                        {input.id === 'email' && <Icons.Mail />}
                        <input
                          type={input.type}
                          placeholder={input.placeholder}
                          id={input.id}
                          value={info[input.id] || ''}
                          onChange={handleChange}
                          className={input.id === 'email' ? 'with-icon' : ''}
                        />
                      </div>
                    </div>
                  ))}
                  <div className="form-group-modern">
                    <label>User Role</label>
                    <div className="select-field-modern">
                      <select
                        id="role"
                        value={info.role || 'user'}
                        onChange={handleChange}
                      >
                        <option value="user">Standard User</option>
                        <option value="admin">Administrator</option>
                      </select>
                      <svg className="select-arrow-modern" width="12" height="7" viewBox="0 0 12 7" fill="none">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Single;